module.exports = __webpack_public_path__ + "static/media/251.9028ce16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/251.jpg
// module id = 966
// module chunks = 0